import React from "react";
import styled from "styled-components";

import { AppContainerProps } from "../../types";

const AppContainerStyled = styled.div`
  display: block;
  position: relative;
  width: 100%;
  padding: 0;
`;

const AppContainer: React.FC<AppContainerProps> = ({ children }) => (
  <AppContainerStyled>{children}</AppContainerStyled>
);

export default AppContainer;
